export const TrialBadgeIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 0C32.9555 0 40.7645 4.90563 44.8887 12.1758L24 24V0Z"
      fill="#5DDCAD"
    />

    <circle cx="24" cy="24" r="22" fill="url(#badge_gradient)" />

    <text
      x="24"
      y="22"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="white"
      fontSize="20"
      fontWeight="700"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      7
    </text>
    <text
      x="24"
      y="34"
      dominantBaseline="middle"
      textAnchor="middle"
      fill="#ECECED"
      fontSize="10"
      fontWeight="500"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      ngày
    </text>

    <defs>
      <linearGradient
        id="badge_gradient"
        x1="2"
        y1="46"
        x2="46"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F7F5C" />
        <stop offset="1" stopColor="#2AA97A" />
      </linearGradient>
    </defs>
  </svg>
);
